import type { ReactNode } from "react";

export interface TitleBarOuterProps {
  children?: ReactNode;
  breakpointDisplay?: "SHOW_LG_UP" | "HIDE_LG_UP";
  bordered?: boolean;
}

const TitleBarOuter = ({
  children = null,
  breakpointDisplay,
  bordered = false,
}: TitleBarOuterProps) => {
  const outerCss = `h-14 px-5 items-center gap-4 sticky top-0 inset-x-0 z-20 backdrop-blur-sm`;
  const borderCss = bordered ? `shadow-md bg-e-color-surface/80` : "";

  // const displayCss = "flex";
  let displayCss = "flex";
  if (breakpointDisplay) {
    if (breakpointDisplay === "SHOW_LG_UP") {
      displayCss = `hidden lg:flex`;
    } else if (breakpointDisplay === "HIDE_LG_UP") {
      displayCss = `flex lg:hidden`;
    }
  }

  return <div className={`${outerCss} ${displayCss} ${borderCss}`}>{children}</div>;
};

export default TitleBarOuter;
